export const Direction = {
	HORIZONTAL: 'HORIZONTAL',
	VERTICAL: 'VERTICAL',
};
